import { render, staticRenderFns } from "./IaraEvenBaixoImpactoTable.vue?vue&type=template&id=64b2a9df&lang=pug"
import script from "./IaraEvenBaixoImpactoTable.vue?vue&type=script&lang=js"
export * from "./IaraEvenBaixoImpactoTable.vue?vue&type=script&lang=js"
import style0 from "./IaraEvenBaixoImpactoTable.vue?vue&type=style&index=0&id=64b2a9df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports